import { analyticsConfig } from '../config/analytics';

export function initializeAnalytics(): Promise<void> {
  return new Promise((resolve) => {
    if (!analyticsConfig.enabled) {
      if (analyticsConfig.debug) {
        console.log('Analytics disabled');
      }
      resolve();
      return;
    }

    // Initialize dataLayer if not already present
    window.dataLayer = window.dataLayer || [];

    // Initialize gtag function if not already present
    if (typeof window.gtag !== 'function') {
      window.gtag = function gtag(...args: any[]) {
        window.dataLayer.push(args);
      };
    }

    // Wait for GTM to be fully loaded
    const checkGTM = () => {
      if (typeof window.gtag === 'function' && window.dataLayer) {
        if (analyticsConfig.debug) {
          console.log('Google Tag Manager ready with ID:', analyticsConfig.gtmId);
          console.log('DataLayer:', window.dataLayer);
        }
        resolve();
      } else {
        // Check again in 100ms
        setTimeout(checkGTM, 100);
      }
    };

    // Start checking for GTM
    checkGTM();
  });
}

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
} 